<template>
  <jr-button class="boundary-prev" type="info" style="width: 100%" @click="prev"> 戻る </jr-button>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { BoundarySteps } from '@/constants/enums'
import JrButton from '@/components/jr-parts/JrButton.vue'

/**
 * 境界立会申請の戻るボタンコンポーネント
 */
export default defineComponent({
  name: 'BoundaryPrev',
  emits: ['update:modelValue'],
  components: {
    JrButton,
  },
  props: {
    // step
    modelValue: {
      type: Number,
      required: true,
    },
  },
  setup(props, context) {
    const prev = () => {
      // 確認画面の場合、入力Stepに切替
      if (props.modelValue === BoundarySteps.CONFIRM) {
        context.emit('update:modelValue', BoundarySteps.INPUT)
        return
      }
    }

    return {
      prev,
    }
  },
})
</script>
